module.exports = __webpack_public_path__ + "static/media/design.d17b4928.png";